import { useState, type ReactNode } from "react";
import { AutoComplete } from "@/core/components/ui/autocomplete/autocomplete";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import type { PeriodOption } from "./types";

export const PeriodSelector = ({
  options,
  value,
  onValueChange,
  status,
}: {
  options: PeriodOption[];
  value?: string;
  onValueChange: (value: string) => void;
  /**
   * Rendered at the end of the label's row. Beside the selector instead, anything
   * here takes width the period needs; on the label's line it costs nothing, since
   * "Pay Period" is two words and the rest of that row was empty.
   */
  status?: ReactNode;
}) => {
  const [searchValue, setSearchValue] = useState("");

  return (
    <Stack gap="sm" fullWidth>
      <Stack
        direction="row"
        align="center"
        justify="between"
        gap="sm"
        fullWidth
      >
        <Typography variant="subtitleW3" textColor="secondary">
          Pay Period
        </Typography>
        {status}
      </Stack>
      <div className="w-full min-w-0 [&_.absolute.top-0]:min-w-[260px]">
        <AutoComplete
          selectedValue={value ?? ""}
          onSelectedValueChange={onValueChange}
          searchValue={searchValue}
          onSearchValueChange={setSearchValue}
          items={options}
          placeholder="Select a pay period"
          className="border-border bg-card shadow"
          fullWidth
        />
      </div>
    </Stack>
  );
};
